export default __webpack_public_path__ + "assets/images/a3fce67e79828c151eb7367fbd4727d7.svg";